import { Heading, List, Stack, Text } from '@chakra-ui/react';

export const TCPT = () => {
  return (
    <div>
      <Heading as="h1" size="md" mt={4}>
        TERMOS E CONDIÇÕES GERAIS
      </Heading>
      <Text fontWeight="bold" mt={2}>
        SUP SUP CLUB B.V.
      </Text>
      <Text fontStyle="italic">(Versão 2026)</Text>
      <Stack gap={4} mt={4}>
        <Heading size="md">Artigo 1 – Definições</Heading>
        <Text fontWeight="bold">Sup Sup Club</Text>
        <Text>
          Sup Sup Club B.V., sociedade de responsabilidade limitada constituída
          ao abrigo do direito neerlandês, com sede estatutária em Amesterdão e
          endereço comercial em Herengracht 406, 1017 BX Amesterdão, registada
          na Câmara de Comércio dos Países Baixos sob o número 81205309.
        </Text>
        <Text fontWeight="bold">Website</Text>
        <Text>
          www.supsupclub.com ou qualquer outro website designado pela Sup Sup
          Club.
        </Text>
        <Text fontWeight="bold">Aplicação Web</Text>
        <Text>
          O ambiente digital acessível através de app2.supsupclub.com ou outro
          URL designado pela Sup Sup Club, através do qual são efetuadas
          reservas e abertas as lockers.
        </Text>
        <Text fontWeight="bold">Serviço de Apoio ao Cliente</Text>
        <Text>
          Contactável através do número +31 85 130 9686, do e-mail
          info@supsupclub.com ou através das opções de contacto indicadas na
          Aplicação Web.
        </Text>
        <Text fontWeight="bold">Estação</Text>
        <Text>
          Estação automatizada e não tripulada onde se encontram pranchas de
          SUP, acessórios e lockers.
        </Text>
        <Text fontWeight="bold">Locker</Text>
        <Text>
          Compartimentos fecháveis dentro da Estação, acessíveis através da
          Aplicação Web.
        </Text>
        <Text fontWeight="bold">Aluguer em Self-Service</Text>
        <Text>
          Aluguer automatizado de pranchas de SUP sem presença física,
          supervisão, instrução ou acompanhamento por parte de pessoal.
        </Text>
        <Text fontWeight="bold">Participante</Text>
        <Text>
          Qualquer pessoa singular que utilize uma prancha de SUP ou Locker
          reservada através da Sup Sup Club.
        </Text>
        <Text fontWeight="bold">Participante Responsável pela Reserva</Text>
        <Text>
          A pessoa singular que reserva uma ou várias pranchas de SUP através da
          Aplicação Web.
        </Text>
        <Text fontWeight="bold">Contrato</Text>
        <Text>
          O contrato entre a Sup Sup Club e o Participante para a utilização
          temporária de uma prancha de SUP, Locker e Estação.
        </Text>

        <Heading size="md">
          Artigo 2 – Parte Contratante &amp; Modelo Self-Service
        </Heading>
        <List.Root>
          <List.Item>
            O Contrato é celebrado exclusivamente entre o Participante e a Sup
            Sup Club B.V.
          </List.Item>
          <List.Item>
            Eventuais franqueados, proprietários do local ou outras partes
            envolvidas não são partes contratantes do Contrato.
          </List.Item>
          <List.Item>
            A Sup Sup Club é fornecedora de aluguer automatizado de desportos
            aquáticos em self-service.
          </List.Item>
          <List.Item>
            Em princípio, não existe qualquer funcionário da Sup Sup Club,
            franqueado ou proprietário do local fisicamente presente na Estação.
          </List.Item>
          <List.Item>
            Não existe supervisão, instrução ou serviço de salvamento
            disponível.
          </List.Item>
          <List.Item>
            O Participante reconhece expressamente que utiliza o equipamento de
            forma independente e sem acompanhamento.
          </List.Item>
        </List.Root>

        <Heading size="md">
          Artigo 3 – Formação do Contrato &amp; Reservas de Grupo
        </Heading>
        <Text>O Contrato é celebrado quando:</Text>
        <List.Root>
          <List.Item>é efetuada uma reserva através da Aplicação Web;</List.Item>
          <List.Item>estes Termos e Condições são aceites;</List.Item>
          <List.Item>e o pagamento é concluído.</List.Item>
        </List.Root>
        <Text>
          O Contrato termina automaticamente após o período de aluguer
          reservado.
        </Text>
        <Text>
          Caso o Participante Responsável pela Reserva reserve várias pranchas:
        </Text>
        <List.Root>
          <List.Item>
            declara estar autorizado a celebrar o Contrato em nome dos restantes
            utilizadores;
          </List.Item>
          <List.Item>
            declara que todos os utilizadores tomaram conhecimento e aceitam
            estes Termos e Condições;
          </List.Item>
          <List.Item>
            garante que todos cumprem os requisitos de participação.
          </List.Item>
        </List.Root>
        <Text>
          O Participante Responsável pela Reserva é solidariamente responsável
          por danos causados pelos utilizadores registados por si.
        </Text>
        <Text>
          Cada utilizador adicional será considerado individualmente como
          Participante para efeitos destes Termos.
        </Text>

        <Heading size="md">Artigo 4 – Requisitos de Participação</Heading>
        <Text>
          A idade mínima para aluguer independente é 18 anos.
        </Text>
        <Text>O Participante declara:</Text>
        <List.Root>
          <List.Item>
            possuir pelo menos o certificado neerlandês de natação A, ou um
            nível equivalente de competência básica de natação que permita nadar
            de forma independente em águas abertas e colocar-se em segurança;
          </List.Item>
          <List.Item>estar fisicamente apto a praticar stand-up paddle;</List.Item>
          <List.Item>
            não estar sob influência de álcool, drogas ou substâncias
            semelhantes.
          </List.Item>
        </List.Root>
        <Text>
          Menores apenas podem utilizar o equipamento sob supervisão direta de
          um adulto (18+) que também possua o certificado neerlandês de natação
          A ou nível equivalente.
        </Text>
        <Text>
          A Sup Sup Club não fornece coletes salva-vidas no aluguer em
          self-service.
        </Text>
        <Text>
          O Participante reconhece que a ausência de coletes salva-vidas faz
          parte do caráter self-service do aluguer e assume total
          responsabilidade nesse aspeto.
        </Text>
        <Text>
          A Sup Sup Club reserva-se o direito de recusar a participação sem
          necessidade de justificação.
        </Text>

        <Heading size="md">Artigo 5 – Assunção de Risco</Heading>
        <Text>
          O Participante reconhece que os desportos aquáticos, incluindo
          stand-up paddle, envolvem riscos inerentes, incluindo mas não se
          limitando a:
        </Text>
        <List.Root>
          <List.Item>afogamento;</List.Item>
          <List.Item>hipotermia;</List.Item>
          <List.Item>correntes;</List.Item>
          <List.Item>colisões;</List.Item>
          <List.Item>alterações súbitas das condições meteorológicas;</List.Item>
          <List.Item>lesões físicas.</List.Item>
        </List.Root>
        <Text>O Participante reconhece expressamente que:</Text>
        <List.Root>
          <List.Item>não existe supervisão física;</List.Item>
          <List.Item>não existe serviço de salvamento;</List.Item>
          <List.Item>não são fornecidos coletes salva-vidas;</List.Item>
          <List.Item>
            é exclusivamente responsável por avaliar as condições
            meteorológicas, da água e a sua própria segurança.
          </List.Item>
        </List.Root>
        <Text>
          A utilização do equipamento é feita inteiramente por conta e risco do
          Participante.
        </Text>

        <Heading size="md">
          Artigo 6 – Equipamento, Locker &amp; Utilização Cuidadosa
        </Heading>
        <List.Root>
          <List.Item>
            O Participante deve inspecionar a prancha de SUP, acessórios, Locker
            e Estação quanto a defeitos visíveis antes da utilização.
          </List.Item>
          <List.Item>
            O Participante deve utilizar a prancha, Locker e Estação com cuidado
            e de acordo com as instruções indicadas na Aplicação Web e na
            Estação.
          </List.Item>
          <List.Item>
            A abertura e fecho da Locker é efetuada inteiramente por conta e
            risco do Participante.
          </List.Item>
          <List.Item>
            A utilização da Locker é feita por conta e risco do Participante.
          </List.Item>
          <List.Item>
            A Sup Sup Club não assume qualquer obrigação de guarda relativamente
            aos objetos colocados na Locker.
          </List.Item>
          <List.Item>
            A Sup Sup Club não é responsável por perda, furto ou danos de
            objetos deixados na ou junto à Locker.
          </List.Item>
          <List.Item>
            O Participante é expressamente aconselhado a não deixar objetos de
            valor na Locker.
          </List.Item>
        </List.Root>
        <Text>Em caso de dúvida ou defeito:</Text>
        <List.Root>
          <List.Item>o equipamento ou Locker não deve ser utilizado;</List.Item>
          <List.Item>
            a Sup Sup Club deve ser contactada imediatamente.
          </List.Item>
        </List.Root>
        <Text>
          A Sup Sup Club está autorizada a desativar imediatamente uma Locker ou
          Estação caso a segurança o exija.
        </Text>

        <Heading size="md">
          Artigo 7 – Preços, Alterações &amp; Cancelamento
        </Heading>
        <Text>
          O pagamento deve ser efetuado antecipadamente através do sistema
          digital.
        </Text>
        <Text>
          O Participante pode alterar a reserva até quatro (4) horas antes do
          início do período reservado, exclusivamente através da Aplicação Web e
          sujeito a disponibilidade.
        </Text>
        <Text>A alteração não dá direito a reembolso.</Text>
        <Text>
          O cancelamento por parte do Participante não dá direito a reembolso.
        </Text>
        <Text>
          A Sup Sup Club pode cancelar ou suspender a reserva em caso de:
        </Text>
        <List.Root>
          <List.Item>condições meteorológicas extremas;</List.Item>
          <List.Item>riscos de segurança;</List.Item>
          <List.Item>medidas governamentais;</List.Item>
          <List.Item>falhas técnicas.</List.Item>
        </List.Root>
        <Text>
          Nesse caso, será primeiro oferecida a possibilidade de reagendar
          gratuitamente.
        </Text>
        <Text>
          Caso o reagendamento não seja possível ou não seja aceite, o valor
          pago será reembolsado.
        </Text>

        <Heading size="md">Artigo 8 – Responsabilidade</Heading>
        <Text>
          A Sup Sup Club apenas será responsável em caso de dolo ou negligência
          grave dos seus administradores estatutários.
        </Text>
        <Text>
          Qualquer responsabilidade está limitada ao montante pago pela
          seguradora aplicável.
        </Text>
        <Text>A Sup Sup Club não é responsável por:</Text>
        <List.Root>
          <List.Item>afogamento;</List.Item>
          <List.Item>lesões pessoais;</List.Item>
          <List.Item>danos indiretos;</List.Item>
          <List.Item>perda ou furto de bens pessoais;</List.Item>
          <List.Item>danos resultantes de condições meteorológicas;</List.Item>
          <List.Item>
            lesões decorrentes da utilização da Estação ou Locker, salvo em caso
            de dolo ou negligência grave.
          </List.Item>
        </List.Root>
        <Text>
          A utilização da prancha, Locker e Estação é feita inteiramente por
          conta e risco do Participante.
        </Text>
        <Text>
          Estas limitações aplicam-se igualmente a franqueados, proprietários do
          local, colaboradores e auxiliares.
        </Text>
        <Text>
          O Participante indemniza a Sup Sup Club por reclamações de terceiros
          decorrentes da sua utilização.
        </Text>

        <Heading size="md">Artigo 9 – Danos</Heading>
        <Text>
          O Participante é responsável por danos causados à prancha, acessórios,
          Locker ou Estação, caso resultem de negligência, utilização indevida
          ou conduta intencional.
        </Text>

        <Heading size="md">Artigo 10 – Força Maior</Heading>
        <Text>
          A Sup Sup Club não é responsável por incumprimento resultante de força
          maior, incluindo condições meteorológicas extremas, desastres
          naturais, medidas governamentais ou falhas técnicas.
        </Text>

        <Heading size="md">Artigo 11 – Dados Pessoais</Heading>
        <Text>
          Os dados pessoais são tratados de acordo com o Regulamento Geral sobre
          a Proteção de Dados (RGPD) e a Política de Privacidade da Sup Sup
          Club.
        </Text>

        <Heading size="md">Artigo 12 – Lei Aplicável</Heading>
        <List.Root>
          <List.Item>
            Todas as relações jurídicas são regidas exclusivamente pelo direito
            neerlandês.
          </List.Item>
          <List.Item>
            Quaisquer litígios serão submetidos exclusivamente ao tribunal
            competente em Amesterdão.
          </List.Item>
          <List.Item>
            Em caso de divergência entre a versão neerlandesa e esta versão
            portuguesa, prevalece a versão neerlandesa.
          </List.Item>
        </List.Root>
      </Stack>
    </div>
  );
};
